import { connect } from 'react-redux';
import ProfileTagsManagement from '../ProfileTagsManagement';

import * as actions from '../../../campaigns/actions';
import { logout } from '../../../auth/actions';

const mapStateToProps = state => ({
  isAdmin: state.auth.isAdmin,
  isAuthenticated: state.auth.isAuthenticated,
  isProcessing: state.campaigns.isProcessing,
  isFetching: state.campaigns.isFetching,
  clientEmail: state.auth.clientEmail,
  isProfilingTagsManager: state.auth.isProfilingTagsManager
});

const mapDispatchToProps = dispatch => ({
  onGoToPortalPage: (onSuccess, history) =>
    dispatch(actions.goToPortalPage(onSuccess, history)),
  onLogout: () => dispatch(logout())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileTagsManagement);
